import { render, staticRenderFns } from "./htmldoc.vue?vue&type=template&id=53f23929&scoped=true&"
import script from "./htmldoc.vue?vue&type=script&lang=js&"
export * from "./htmldoc.vue?vue&type=script&lang=js&"
import style0 from "./htmldoc.vue?vue&type=style&index=0&id=53f23929&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f23929",
  null
  
)

export default component.exports